/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type StudentHistory_student = {|
  +history: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string;
      |};
    |}>;
    +pageInfo: {|
      +hasNextPage: boolean;
    |};
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "historyCount",
      "type": "Int"
    },
    {
      "kind": "RootArgument",
      "name": "historyCursor",
      "type": "String"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "historyCount",
        "cursor": "historyCursor",
        "direction": "forward",
        "path": [
          "history"
        ]
      }
    ]
  },
  "name": "StudentHistory_student",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "history",
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": [
            {
              "field": "startDate",
              "direction": "desc"
            }
          ],
          "type": "[JobSessionOrder]"
        },
        {
          "kind": "Literal",
          "name": "status",
          "value": [
            "Completed"
          ],
          "type": "[JobSessionStatus]"
        }
      ],
      "concreteType": "JobSessionConnection",
      "name": "__StudentHistory_history_connection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "JobSessionEdge",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "JobSession",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "id",
                  "storageKey": null
                },
                {
                  "kind": "FragmentSpread",
                  "name": "StudentJobSessionHistory_session",
                  "args": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "hasNextPage",
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "endCursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "__StudentHistory_history_connection{\"orderBy\":[{\"direction\":\"desc\",\"field\":\"startDate\"}],\"status\":[\"Completed\"]}"
    }
  ],
  "type": "Student"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/modules/admin/student/components/__generated__/StudentHistory_student.graphql.js